import { z } from "zod";

/**
 * `.design` bundle (SPEC.md §6): a zip with manifest.json, document.json,
 * assets/<sha256>.<ext> and thumbnail.png. Independent of any server's storage layout.
 */
export const BUNDLE_FORMAT = 1;

export const BundleManifest = z.object({
  format: z.literal(BUNDLE_FORMAT),
  app: z.literal("canvas-editor"),
  schemaVersion: z.int(),
  exportedAt: z.string(),
  assets: z.array(z.object({ id: z.string().regex(/^[0-9a-f]{64}$/), path: z.string(), mime: z.string() })),
  /**
   * Small pictures of pages (webp/png) for page strips and grids, so opening a big design
   * doesn't have to render every page first. Optional; a page without one is rendered.
   */
  pageThumbnails: z.array(z.object({ pageId: z.string(), path: z.string() })).optional(),
});
export type BundleManifest = z.infer<typeof BundleManifest>;

export const MIME_EXT: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
  "image/avif": "avif",
  "image/gif": "gif",
};
